/** 운영지표 공용 포매터 */

export const formatNumber = (value: number): string => new Intl.NumberFormat('ko-KR').format(value)

/** 축 라벨용 축약 표기 (1.2만, 3.4억) */
export const formatCompact = (value: number): string =>
  new Intl.NumberFormat('ko-KR', { notation: 'compact' }).format(value)

export const formatCurrency = (currencyCode: string | null | undefined, value: number): string => {
  // DB에 통화가 저장되지 않은 레거시 데이터는 전부 원화로 간주
  const code = currencyCode || 'KRW'
  return new Intl.NumberFormat(code === 'KRW' ? 'ko-KR' : 'en-US', {
    style: 'currency',
    currency: code,
    maximumFractionDigits: code === 'KRW' ? 0 : 2,
  }).format(value)
}

/** 0~1 비율 → "12.3%" */
export const formatRate = (rate: number): string => `${(rate * 100).toFixed(1)}%`

/** 초 단위 → "1분 35초" / "1시간 2분" */
export const formatSeconds = (seconds: number | null | undefined): string => {
  if (seconds == null) return '—'
  const s = Math.round(seconds)
  if (s < 60) return `${s}초`
  if (s < 3600) return `${Math.floor(s / 60)}분 ${s % 60}초`
  return `${Math.floor(s / 3600)}시간 ${Math.floor((s % 3600) / 60)}분`
}

/** 시간 단위 → "4시간" / "2일 3시간" */
export const formatHours = (hours: number | null | undefined): string => {
  if (hours == null) return '—'
  const h = Math.round(hours)
  if (h < 24) return `${h}시간`
  return `${Math.floor(h / 24)}일 ${h % 24}시간`
}

/** 분 단위 → "23분" / "2시간 3분" / "1일 22시간" */
export const formatMinutes = (minutes: number | null | undefined): string => {
  if (minutes == null) return '—'
  const m = Math.round(minutes)
  if (m < 60) return `${m}분`
  const h = Math.floor(m / 60)
  const rm = m % 60
  if (h < 24) return rm ? `${h}시간 ${rm}분` : `${h}시간`
  const d = Math.floor(h / 24)
  const rh = h % 24
  return rh ? `${d}일 ${rh}시간` : `${d}일`
}
